import { render, staticRenderFns } from "./ConversationHeading.vue?vue&type=template&id=b3c21f2e&scoped=true&"
import script from "./ConversationHeading.vue?vue&type=script&lang=js&"
export * from "./ConversationHeading.vue?vue&type=script&lang=js&"
import style0 from "./ConversationHeading.vue?vue&type=style&index=0&id=b3c21f2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c21f2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
